import { render } from "./PetromilConfig.vue?vue&type=template&id=42325f3e&scoped=true"
import script from "./PetromilConfig.vue?vue&type=script&lang=js"
export * from "./PetromilConfig.vue?vue&type=script&lang=js"

import "./PetromilConfig.vue?vue&type=style&index=0&id=42325f3e&scoped=true&lang=css"

import exportComponent from "D:\\WGitHub\\Kubber\\kubber\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-42325f3e"]])

export default __exports__